import { render } from "./TextNumber.vue?vue&type=template&id=5e188169&scoped=true"
import script from "./TextNumber.vue?vue&type=script&lang=js"
export * from "./TextNumber.vue?vue&type=script&lang=js"

import "./TextNumber.vue?vue&type=style&index=0&id=5e188169&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e188169"]])

export default __exports__